
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nm/news/cure-hackathon",
      function () {
        return require("private-next-pages/nm/news/cure-hackathon.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nm/news/cure-hackathon"])
      });
    }
  